/// <reference path="./Service.ts" />
namespace HA.Core.Service {

    export class HorApp extends Service {

        public showApp(id: string): void {
            this.getPage().showApp(toMap({id : id}));
        }

        public toggleApp(id: string): void {
            this.getPage().toggleApp(toMap({id : id}));
        }

        public reloadApp(id: string): void {
            this.getPage().reloadApp(toMap({id : id}));
        }

        protected getPage(): WebPage {
            return this.get("pages");
        }

        protected initialize(data: any) {
            this.addToData("pages", new WebPage(data));
        }
    }
}
